export class RegistrationUser
{
    public FName: string;
    public LName: string;
    public Email: string;
}
